import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { memo } from "react";

export const OrderItemsCell = memo(function OrderItemsCell({
  totalItemQuantity,
}: {
  totalItemQuantity: number;
}) {
  return <RedoTableTextCell text={String(totalItemQuantity)} />;
});
